import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import AccountIcon from "areas/header/dropdowns/account-icon"
import CartIcon from "areas/header/dropdowns/cart-icon"
import WishlistIcon from "areas/header/dropdowns/wishlist-icon"
import CountrySelector from "areas/header/jewlr/country-selector"
import { Box, Flex } from "components/common/index"

const HeaderLink = styled(Box)`
  position: relative;
`

const InternalHeaderDropdowns = () => {
  return (
    <Flex alignItems="flex-end" gutter={1}>
      <HeaderLink>
        <AccountIcon dropdown="account" />
      </HeaderLink>
      <HeaderLink id="react_header_wishlist">
        <WishlistIcon dropdown="wishlist" />
      </HeaderLink>
      <HeaderLink>
        <CartIcon />
      </HeaderLink>
      <HeaderLink>
        <CountrySelector />
      </HeaderLink>
    </Flex>
  )
}

const mapStateToProps = () => {
  return {}
}
const mapDispatchToProps = () => {
  return {}
}

InternalHeaderDropdowns.propTypes = {}

const HeaderDropdowns = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalHeaderDropdowns)

export default HeaderDropdowns
